import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import { defineMessages } from 'react-intl'

export const SEARCH_DOMAIN = 'search'
export const SEARCH_STATE = {
  query: ''
}

export const SEARCH_ACTION = {
  UPDATE_QUERY: 'SEARCH_UPDATE_QUERY'
}

export const SEARCH_PATH = {
  QUERY: `${SEARCH_DOMAIN}.query`
}

export const SEARCH_SECTION_ITEMS_COUNT = {
  [SECTIONS_NAME.ARTICLES]: 10,
  [SECTIONS_NAME.MOTIVATION]: 10,
  [SECTIONS_NAME.STORE]: 10
}

/**
 * A mapping of section name to items.
 * @private
 * @type {Object}
 */
export const SECTION_TO_ITEMS = {
  Articles: 'articles',
  Motivation: 'motivation',
  Plans: 'plans',
  Workouts: 'workouts',
  Exercises: 'exercises'
  // Pages: 'pages',
  // Store: 'products'
}

/**
 * A mapping of section name to items.
 * @private
 * @type {Object}
 */
export const APP_SECTIONS = [
  SECTION_TO_ITEMS.Plans,
  SECTION_TO_ITEMS.Workouts,
  SECTION_TO_ITEMS.Exercises
]

export const sectionSearchMessages = defineMessages({
  // Articles
  howToLoseWeight: { defaultMessage: 'how to lose weight' },
  benefitsOfStrengthTraining: { defaultMessage: 'benefits of strength training' },
  whatToEatBeforeWorkout: { defaultMessage: 'what to eat before a workout' },
  intermittentFastingGuide: { defaultMessage: 'intermittent fasting guide' },
  betterSleep: { defaultMessage: 'how to get better sleep' },
  hiitVsLiss: { defaultMessage: 'HIIT vs LISS' },
  calisthenicsVsGym: { defaultMessage: 'calisthenics vs gym' },
  cardioVsStrength: { defaultMessage: 'cardio vs strength training' },
  bestSupplements: { defaultMessage: 'best supplements for fitness' },
  theScienceOfMotivation: { defaultMessage: 'the science of motivation' },

  // Motivation
  consistency: { defaultMessage: 'consistency' },
  failure: { defaultMessage: 'failure' },
  pain: { defaultMessage: 'pain' },
  discipline: { defaultMessage: 'discipline' },
  talent: { defaultMessage: 'talent' },
  gym: { defaultMessage: 'gym' },

  // Common terms used in Plans/Workouts
  women: { defaultMessage: 'women' },
  men: { defaultMessage: 'men' },
  calisthenics: { defaultMessage: 'calisthenics' },
  summer: { defaultMessage: 'summer' },
  fatLoss: { defaultMessage: 'fat loss' },
  beginner: { defaultMessage: 'beginner' },
  intermediate: { defaultMessage: 'intermediate' },
  advanced: { defaultMessage: 'advanced' },
  hiit: { defaultMessage: 'hiit' },
  powerhybrid: { defaultMessage: 'powerhybrid' },
  home: { defaultMessage: 'home' },
  dumbbell: { defaultMessage: 'dumbbell' },
  fullBody: { defaultMessage: 'full body' },
  kettlebell: { defaultMessage: 'kettlebell' },
  resistanceBand: { defaultMessage: 'resistance band' },
  running: { defaultMessage: 'running' },
  senior: { defaultMessage: 'senior' },
  upper: { defaultMessage: 'upper' },
  abs: { defaultMessage: 'abs' },
  legs: { defaultMessage: 'legs' },
  stretching: { defaultMessage: 'stretching' },
  liss: { defaultMessage: 'liss' },
  recovery: { defaultMessage: 'recovery' },
  painRelief: { defaultMessage: 'pain relief' },
  mobility: { defaultMessage: 'mobility' },
  tabata: { defaultMessage: 'tabata' },
  kneeSafe: { defaultMessage: 'knee safe' },
  hipSafe: { defaultMessage: 'hip safe' },
  backSafe: { defaultMessage: 'back safe' },
  shoulderSafe: { defaultMessage: 'shoulder safe' },
  wheelchair: { defaultMessage: 'wheelchair' },

  // Exercises
  squat: { defaultMessage: 'squat' },
  deadlift: { defaultMessage: 'deadlift' },
  benchPress: { defaultMessage: 'bench press' },
  pullUp: { defaultMessage: 'pull up' },
  shoulderPress: { defaultMessage: 'shoulder press' },
  bicepCurl: { defaultMessage: 'bicep curl' },
  tricepDip: { defaultMessage: 'tricep dip' },
  legPress: { defaultMessage: 'leg press' },
  plank: { defaultMessage: 'plank' },
  lunge: { defaultMessage: 'lunge' }
})

export const SECTION_TO_SEARCH_TERMS = {
  [SECTION_TO_ITEMS.Articles]: [
    sectionSearchMessages.howToLoseWeight,
    sectionSearchMessages.benefitsOfStrengthTraining,
    sectionSearchMessages.whatToEatBeforeWorkout,
    sectionSearchMessages.calisthenicsVsGym,
    sectionSearchMessages.intermittentFastingGuide,
    sectionSearchMessages.betterSleep,
    sectionSearchMessages.hiitVsLiss,
    sectionSearchMessages.cardioVsStrength,
    sectionSearchMessages.bestSupplements,
    sectionSearchMessages.theScienceOfMotivation
  ],
  [SECTION_TO_ITEMS.Motivation]: [
    sectionSearchMessages.consistency,
    sectionSearchMessages.failure,
    sectionSearchMessages.pain,
    sectionSearchMessages.discipline,
    sectionSearchMessages.talent,
    sectionSearchMessages.gym
  ],
  [SECTION_TO_ITEMS.Plans]: [
    sectionSearchMessages.women,
    sectionSearchMessages.men,
    sectionSearchMessages.calisthenics,
    sectionSearchMessages.summer,
    sectionSearchMessages.fatLoss,
    sectionSearchMessages.beginner,
    sectionSearchMessages.intermediate,
    sectionSearchMessages.advanced,
    sectionSearchMessages.hiit,
    sectionSearchMessages.powerhybrid,
    sectionSearchMessages.home,
    sectionSearchMessages.dumbbell,
    sectionSearchMessages.fullBody,
    sectionSearchMessages.kettlebell,
    sectionSearchMessages.resistanceBand,
    sectionSearchMessages.running,
    sectionSearchMessages.senior
  ],
  [SECTION_TO_ITEMS.Workouts]: [
    sectionSearchMessages.women,
    sectionSearchMessages.men,
    sectionSearchMessages.calisthenics,
    sectionSearchMessages.summer,
    sectionSearchMessages.upper,
    sectionSearchMessages.abs,
    sectionSearchMessages.legs,
    sectionSearchMessages.stretching,
    sectionSearchMessages.fatLoss,
    sectionSearchMessages.beginner,
    sectionSearchMessages.intermediate,
    sectionSearchMessages.advanced,
    sectionSearchMessages.liss,
    sectionSearchMessages.hiit,
    sectionSearchMessages.powerhybrid,
    sectionSearchMessages.fullBody,
    sectionSearchMessages.home,
    sectionSearchMessages.dumbbell,
    sectionSearchMessages.kettlebell,
    sectionSearchMessages.recovery,
    sectionSearchMessages.painRelief,
    sectionSearchMessages.resistanceBand,
    sectionSearchMessages.running,
    sectionSearchMessages.mobility,
    sectionSearchMessages.tabata,
    sectionSearchMessages.kneeSafe,
    sectionSearchMessages.hipSafe,
    sectionSearchMessages.backSafe,
    sectionSearchMessages.shoulderSafe,
    sectionSearchMessages.senior,
    sectionSearchMessages.wheelchair
  ],
  [SECTION_TO_ITEMS.Exercises]: [
    sectionSearchMessages.squat,
    sectionSearchMessages.deadlift,
    sectionSearchMessages.benchPress,
    sectionSearchMessages.pullUp,
    sectionSearchMessages.shoulderPress,
    sectionSearchMessages.bicepCurl,
    sectionSearchMessages.tricepDip,
    sectionSearchMessages.legPress,
    sectionSearchMessages.plank,
    sectionSearchMessages.lunge
  ]
}

export const generalSearchMessages = defineMessages({
  // Fitness goals
  weightLoss: { defaultMessage: 'weight loss' },
  bulk: { defaultMessage: 'bulk' },
  cutting: { defaultMessage: 'cutting' },
  muscleGain: { defaultMessage: 'muscle gain' },
  strength: { defaultMessage: 'strength' },
  recomp: { defaultMessage: 'body recomposition' },
  cardio: { defaultMessage: 'cardio' },
  recovery: { defaultMessage: 'recovery' },
  fatBurning: { defaultMessage: 'fat burning' },

  // Common training methods & keywords
  calisthenics: { defaultMessage: 'calisthenics' },
  hiit: { defaultMessage: 'hiit' },
  fullBody: { defaultMessage: 'full body' },
  homeWorkout: { defaultMessage: 'home workout' },
  dumbbell: { defaultMessage: 'dumbbell' },
  resistanceBand: { defaultMessage: 'resistance band' },
  running: { defaultMessage: 'running' },
  beginner: { defaultMessage: 'beginner' },
  advanced: { defaultMessage: 'advanced' },
  intermediate: { defaultMessage: 'intermediate' },
  fatLoss: { defaultMessage: 'fat loss' }
})

export const GENERAL_SEARCH_TERMS = [
  generalSearchMessages.weightLoss,
  generalSearchMessages.bulk,
  generalSearchMessages.cutting,
  generalSearchMessages.muscleGain,
  generalSearchMessages.strength,
  generalSearchMessages.recomp,
  generalSearchMessages.cardio,
  generalSearchMessages.recovery,
  generalSearchMessages.fatBurning,

  generalSearchMessages.calisthenics,
  generalSearchMessages.hiit,
  generalSearchMessages.fullBody,
  generalSearchMessages.homeWorkout,
  generalSearchMessages.dumbbell,
  generalSearchMessages.resistanceBand,
  generalSearchMessages.running,
  generalSearchMessages.beginner,
  generalSearchMessages.intermediate,
  generalSearchMessages.advanced,
  generalSearchMessages.fatLoss
]
